import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Input,
  Select,
  Textarea,
  useDisclosure,
} from '@chakra-ui/react'
import { PlayIcon, UserGroupIcon } from '@heroicons/react/24/solid'
import { useDispatch, useSelector } from 'react-redux'
import {
  openCreateGuestModal,
  closeCreateGuestModal,
} from '../redux/CreateGuestsModal'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

function CreateGuests() {
  const dispatch = useDispatch()
  const isModalOpen = useSelector((state) => state.guestsModal.isModalOpen)

  const { isOpen, onOpen, onClose } = useDisclosure()

  const [value, setValue] = useState('')

  const handleOpenModal = () => {
    dispatch(openCreateGuestModal())
    // Additional logic, if needed
    onOpen()
  }

  const handleCloseModal = () => {
    dispatch(closeCreateGuestModal())
    // Additional logic, if needed
    onClose()
  }
  return (
    <>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create New Guests</ModalHeader>
          <ModalCloseButton />
          <ModalBody className="flex flex-col mx-auto justify-center items-center space-y-4 w-full">
            <Input type="text" placeholder="First name" required />
            <Input type="text" placeholder="Last name" required />
            <Input type="email" placeholder="Email" required />
            <PhoneInput
              placeholder="Enter phone number"
              value={value}
              onChange={setValue}
              className="w-full p-2"
            />
            <Input type="text" placeholder="Contact URL" required />
            <Input type="text" placeholder="Company URL" required />
            <Select
              placeholder="Default timezone for this organization"
              className="w-full"
            >
              <option value="utc">UTC</option>
              <option value="EST">EST</option>
            </Select>
          </ModalBody>

          <ModalFooter className="mt-8">
            <Button
              rightIcon={<PlayIcon className="w-4 h-4 ml-2" />}
              colorScheme="fray"
              mr={3}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              rightIcon={<UserGroupIcon className="w-4 h-4 ml-2" />}
              colorScheme="blue"
              onClick={handleCloseModal} // You can dispatch further actions here
            >
              Create Guest
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default CreateGuests
